import { trackNaverSignUp } from "./naverConversion.js";

// Main과 로그인 후 Labs 복귀가 같은 가입을 중복 기록하지 않도록 기존 표시 키를 공유한다.
export function trackRecentSignup(credits) {
  if (!Array.isArray(credits) || credits.length >= 3) return false;
  try {
    if (localStorage.getItem("welcomeModalShown") === "true") return false;
    const welcome = credits.find((item) => typeof item?.mainContents === "string" && item.mainContents.includes("회원 축하"));
    const age = Date.now() - new Date(welcome?.createdAt).getTime();
    if (!Number.isFinite(age) || age < 0 || age > 50 * 1000) return false;
    localStorage.setItem("welcomeModalShown", "true");
  } catch (_) { return false; }
  // 추적 로더를 기다리거나 실패해도 화면 복귀와 환영 안내를 계속한다.
  Promise.resolve().then(() => trackNaverSignUp()).catch(() => {});
  return true;
}
